import React from 'react';
import SkeletonCell from './SkeletonCell';
import './Skeleton.css';

/**
 * SkeletonRow Component
 * 
 * Composite component - renders a table row with multiple skeleton cells
 * Responsibility: Compose multiple SkeletonCells into a row structure
 * Reusable: Configurable for any table structure
 * 
 * Principles:
 * - Composition Over Inheritance: Built from SkeletonCell components
 * - Unidirectional Data Flow: Accepts columns prop, passes down to cells
 * - Separation of Concerns: Only handles row layout, delegates cell rendering
 */
export default function SkeletonRow({ columns = [] }) {
  return (
    <tr className="skeleton-row">
      {columns.map((column, index) => (
        <td key={index} style={column.style}>
          <SkeletonCell 
            width={column.width || '80%'} 
            height="16px"
          />
        </td>
      ))}
    </tr>
  );
}
